// Module
var code = "<svg viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <circle cx=\"8\" cy=\"8\" r=\"7\" stroke=\"#00B796\" stroke-opacity=\"0.25\" stroke-width=\"2\"/> <path d=\"M8 0.999996C11.866 0.999996 15 4.134 15 8C15 11.866 11.866 15 8 15\" stroke=\"#00B796\" stroke-width=\"2\"/> </svg> ";
// Exports
module.exports = code;